import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { RedocStandalone } from 'redoc'
import { RedocRawOptions } from 'redoc/typings/services/RedocNormalizedOptions'
import { ExternalLinks } from '../../components'
import './docs.scss'
import { useSpecManifest } from '../../hooks'

const options: RedocRawOptions = {
  hideHostname: true,
  theme: {
    colors: {
      primary: { main: '#0A7F85' }
    },
    typography: {
      fontSize: '14px',
      fontFamily: "'Noto Sans', sans-serif",
      headings: {
        fontFamily: "'Noto Sans', sans-serif"
      }
    },
    sidebar: {
      backgroundColor: '#0A004F',
      textColor: '#fff',
      groupItems: {
        activeBackgroundColor: 'none'
      },
      level1Items: {
        activeBackgroundColor: 'none'
      }
    },
    logo: {
      maxHeight: '55px',
      gutter: '15px 0'
    }
  }
}

export const Docs = () => {
  const [loading, setLoading] = useState(true)
  const { status, getVersionUrl } = useSpecManifest()

  const { pathname } = useLocation()
  const spec = pathname.replace(/(^\/)|(\/$)/g, '')

  return (
    <div className="docs-page" data-testid={`doc-${spec.replace(/\//g, '-')}`}>
      <div className="docs-page__top">{!loading && <ExternalLinks />}</div>

      {status === 'SUCCESS' && (
        <RedocStandalone
          data-testid={`doc-${spec.replace(/\//g, '-')}`}
          specUrl={getVersionUrl(spec)}
          options={{ ...options, downloadFileName: `${spec.replace(/\//g, '-')}.yaml` }}
          onLoaded={() => setLoading(false)}
        />
      )}
    </div>
  )
}
